import { useEffect, useState } from 'react';
import { IPE_MODULE_CREDITS_UPDATED_EVENT } from '@/constants/ipeCredits';

/** 订阅 Admin 定价注入后的刷新（setRuntimeModuleCredits 不会触发 React 重渲染） */
export default function useModuleCreditsRevision() {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const onUpdate = () => setRevision((value) => value + 1);
    window.addEventListener(IPE_MODULE_CREDITS_UPDATED_EVENT, onUpdate);
    return () => window.removeEventListener(IPE_MODULE_CREDITS_UPDATED_EVENT, onUpdate);
  }, []);
  return revision;
}
